<template>
    <div class="main-content">
        <el-container class="org-container">
            <el-aside width="260px" class="org-aside">
                <div class="aside-header">
                    <i class="el-icon-office-building"></i>
                    <span>组织架构</span>
                </div>
                <el-menu :default-openeds="['0']" ref="orgMenu" class="org-tree-menu" background-color="transparent" text-color="rgba(255, 255, 255, 0.9)" active-text-color="#ffd591">
                    <el-submenu index="0" @contextmenu.native.stop.prevent="handleRightClick($event,orgNode)">
                        <template slot="title"><i class="el-icon-user-solid"></i>城市</template>
                        <el-menu-item v-for="(item,i) in orgNode.orgList" :key="orgNode.orgId+'-'+i"
                                    :index="orgNode.orgId+'-'+i"
                                    :class="{'is-active': activeOrgId === item.orgId}"
                                    @contextmenu.native.stop.prevent="itemRightClick($event,item)"
                                    @click="getOrgList(item.orgId)">
                            <template slot="title"><i class="el-icon-s-home"></i>{{item.orgName}}</template>
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-aside>

            <el-container>
                <el-main class="org-main">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane name="1" label="到场地详情列表">
                            <el-form :inline="true" :model="searchForm" class="form-content">
                                <el-row :gutter="20" class="slt">
                                    <el-form-item label="到场地名称">
                                        <el-input prefix-icon="el-icon-search" v-model="searchForm.orgName" placeholder="到场地名称" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="到场地代码">
                                        <el-input prefix-icon="el-icon-search" v-model="searchForm.code" placeholder="到场地代码" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" icon="el-icon-search" @click="getOrgList()">查询</el-button>
                                    </el-form-item>
                                </el-row>
                            </el-form>
                            <el-table :data="dataList" border stripe class="org-table" v-loading="dataListLoading" element-loading-text="加载中..." element-loading-background="rgba(255,255,255,0.7)">
                                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                                <el-table-column prop="orgName" label="到场地名称" width="180" align="center"></el-table-column>
                                <el-table-column label="类型" align="center" width="100">
                                    <template slot-scope="scope">
                                        <el-tag v-if="scope.row.orgType==='2'" type="warning" size="small">城市</el-tag>
                                        <el-tag v-if="scope.row.orgType==='3'" size="small">到场地</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="createtime" label="创建时间" align="center" width="200">
                                    <template slot-scope="scope">
                                        {{formatDate(scope.row.createtime)}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" align="center" min-width="380">
                                    <template slot-scope="scope">
                                        <el-button type="primary" icon="el-icon-edit" :disabled="scope.row.orgSupId=='1'" v-if="roleStr=='管理员'" size="mini" @click="addOrUpdateHandler(scope.row)">修改</el-button>
                                        <el-button type="success" icon="el-icon-user" :disabled="scope.row.orgSupId=='1'" size="mini" @click="addCityUser(scope.row)">到场地用户授权</el-button>
                                        <el-button type="info" icon="el-icon-view" :disabled="scope.row.orgSupId=='1'" size="mini" @click="getUserListByOrgId(scope.row.orgId)">查看代理用户</el-button>
                                        <el-button type="danger" icon="el-icon-delete" :disabled="scope.row.orgSupId=='1'" v-if="roleStr=='管理员'" size="mini" @click="deleteHandler(scope.row.orgId)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </el-main>
            </el-container>
        </el-container>
        <!--右键点击菜单-->
        <div class="context-menu" v-show="menuShow" @mouseleave="menuMouseLevel" :style="{ left: left + 'px', top: top + 'px' }">
            <div class="context-menu-item" @click="addOrg" v-if="selectOrgNode.orgType!='3' && roleStr=='管理员'">
                <i class="el-icon-plus"></i>添加
            </div>
            <div class="context-menu-item" @click="editOrg" v-show="delBtn==true && roleStr=='管理员'">
                <i class="el-icon-edit"></i>编辑
            </div>
            <div class="context-menu-item context-menu-item--danger" @click="delOrg" v-show="delBtn && roleStr=='管理员'">
                <i class="el-icon-delete"></i>删除
            </div>
            <div class="context-menu-item" @click="addUser('2')" v-show="selectOrgNode.orgType=='2' && roleStr=='管理员'">
                <i class="el-icon-user"></i>添加城市代理
            </div>
            <div class="context-menu-item" @click="addUser('3')" v-show="selectOrgNode.orgType=='3'">
                <i class="el-icon-user"></i>添加到场地代理
            </div>
            <div class="context-menu-item" @click="getUserListByOrgId(selectOrgNode.orgId)" v-show="selectOrgNode.orgType!='1' && roleStr=='管理员'">
                <i class="el-icon-view"></i>查看代理人
            </div>
            <div class="context-menu-item context-menu-item--cancel" @click="hideMenu">
                <i class="el-icon-close"></i>取消
            </div>
        </div>
        <add-or-update :show="addOrUpdateFlag" :rowData="rowData" v-on:listenToChildEvent="closeDialog"></add-or-update>
        <org-user-list :show="orgUserShow" :rowData="orgUserRowData" v-on:listenToChildEvent="closeOrgUserDialog"></org-user-list>
        <org-user-detail :show="orgUserDetailShow" :rowData="orgUserDetailRowData" v-on:listenToChildEvent="closeDetailDialog"></org-user-detail>
    </div>
</template>
<script>
    import AddOrUpdate from "./add-or-update";
    import orgUserDetail from "./org-user-detail";
    import orgUserList from "./org-user-list";
    import CustomMenu from './CustomMenu.vue';

    export default {
        components: {
            AddOrUpdate,
            orgUserList,
            CustomMenu,
            orgUserDetail
        },
        data() {
            return {
                orgUserDetailShow:false,
                orgUserDetailRowData:{},
                orgUserShow:false,
                orgUserRowData:{},
                delBtn:true,
                dataList: [],
                baseDataList: [],
                activeIndex:'0',
                activeOrgId:'',
                dataListLoading:false,
                menuShow:false,
                isCollapse:false,
                menuRef:null,
                left:0,
                top:0,
                addOrUpdateFlag:false,
                rowData:{},
                orgNode:{},
                selectOrgNode:{},
                searchForm:{
                    title:'',
                },
                pageIndex: 1,
                pageSize: 40,
                totalPage: 0,
                contents:null,
                activeName:'1',
                userDataList:[],
                roleStr:'',
            }
        },
        created(){
            this.initOrgList();
            //this.contentStyleChange();
            this.roleStr = this.$storage.get("role");
        },
        methods:{
            handleRightClick(e,node) {
                node.orgType='1';
                this.selectOrgNode = node;
                // 阻止默认的右键菜单显示
                this.delBtn = false;
                e.preventDefault();
                this.menuShow = true;
                this.left = e.clientX+1;
                this.top = e.clientY+1;
                console.log(this.selectOrgNode);
            },
            itemRightClick(e,node) {
                this.selectOrgNode = node;
                this.delBtn = true;
                // 阻止默认的右键菜单显示
                e.preventDefault();
                this.menuShow = true;
                this.left = e.clientX+1;
                this.top = e.clientY+1;
            },
            siteRightClick(e,node) {
                this.selectOrgNode = node;
                this.delBtn = true;
                // 阻止默认的右键菜单显示
                e.preventDefault();
                this.menuShow = true;
                this.left = e.clientX+1;
                this.top = e.clientY+1;
            },
            hideMenu(){
                this.menuShow = false;
                this.selectOrgNode = {};
            },
            menuMouseLevel(e){
                this.menuShow = false;
                this.left = 0;
                this.top = 0;
            },
            addOrg(){
                this.menuShow = false;
                this.addOrUpdateFlag = true;
                // 根据当前选中节点的orgType决定新建节点的默认orgType
                // 根节点(orgType=1)添加时默认orgType=2(城市)，城市节点(orgType=2)添加时默认orgType=3(到场地)
                let defaultOrgType = this.selectOrgNode.orgType === '1' ? '2' : '3';
                this.rowData = {
                    orgId: this.selectOrgNode.orgId,
                    orgName: this.selectOrgNode.orgName,
                    orgPathname: this.selectOrgNode.orgPathname,
                    path: this.selectOrgNode.path,
                    code: this.selectOrgNode.code,
                    orgType: defaultOrgType,
                    type: 'add'
                };
            },
            editOrg(){
                this.menuShow = false;
                this.addOrUpdateFlag = true;
                // 编辑时复制原始数据，保留原始orgType
                this.rowData = Object.assign({}, this.selectOrgNode, { type: 'edit' });
            },
            addOrUpdateHandler(row){
                this.addOrUpdateFlag = true;
                // 编辑时复制原始数据，保留原始orgType
                this.rowData = Object.assign({}, row, { type: 'edit' });
            },
            handleClick(tab, event) {
//                console.log(tab, event);
            },
            //删除站点架构
            delOrg(){
                this.menuShow = false;
                var ids = [this.selectOrgNode.orgId];
                this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.$http({
                        url: "sysOrg/delete",
                        method: "post",
                        data: ids
                    }).then(({data}) => {
                        if(data && data.code === 0){
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.initOrgList();
                                    this.getOrgList();
                                }
                            });
                        }else{
                            this.$message.error(data.msg);
                        }
                    });
                });
            },
            deleteHandler(id){
                var ids = [id];
                this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.$http({
                        url: "sysOrg/delete",
                        method: "post",
                        data: ids
                    }).then(({data}) => {
                        if(data && data.code === 0){
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.initOrgList();
                                    this.getOrgList();
                                }
                            });
                        }else{
                            this.$message.error(data.msg);
                        }
                    });
                });
            },
            //编辑更新弹窗
            closeDialog(){
                this.addOrUpdateFlag = false;
                this.initOrgList();
                this.getOrgList();
                //this.getDataList();
            },
            closeOrgUserDialog(){
                this.orgUserShow = false;
                this.orgUserRowData = {};
            },
            initOrgList(){
                this.$http({
                    url: "sysOrg/getTreeOrgList",
                    method: "get",
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.orgNode = data.rootOrg;
                    }
                });
            },
            getOrgList(orgId){
                if(orgId != undefined && orgId != ''){
                    this.activeOrgId = orgId;
                }
                // 未选中左侧节点时，不加载右侧列表
                if(!this.activeOrgId){
                    return;
                }
                let params = {};
                if (this.searchForm.orgName!= '' && this.searchForm.orgName!= undefined) {
                    params['t.orgName'] = '%' + this.searchForm.orgName + '%'
                }
                params['t.ORGSUPID'] = this.activeOrgId;
                params['t.isdelete'] = '0';
                params['t.orgType'] = '3';

                this.dataListLoading = true;
                this.$http({
                    url: "sysOrg/list",
                    method: "get",
                    params: params
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.baseDataList = data.data;
                        this.dataList = data.data;
                    }else{
                        this.dataList = [];
                        this.totalPage = 0;
                    }
                    this.dataListLoading = false;
                }).catch(() => {
                    this.dataListLoading = false;
                });
            },
            filterOrgList(orgId){
                let arr = this.baseDataList.filter(item=>{
                    return item.path.indexOf(orgId)!=-1;
                })
                this.dataList = arr;
            },

            getUserListByOrgId(orgId){
                this.orgUserDetailShow = true;
                this.orgUserDetailRowData = {'orgId':orgId};
            },
            closeDetailDialog(){
                this.orgUserDetailShow = false;
                this.orgUserDetailRowData = {};
            },
            formatDate(dateStr){
                let date = new Date(dateStr);
                return date.toLocaleString();
            },
            searchOrgList(e,node){
                e.preventDefault();
                this.getOrgList(node.orgId);
            },
            //每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getOrgList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getOrgList();
            },
            addUser(type){
                this.selectOrgNode.userType = type;
                this.orgUserShow = true;
                this.orgUserRowData = this.selectOrgNode;
                this.menuShow = false;
            },

            addCityUser(row){
                row.userType='3';
                this.orgUserShow = true;
                this.orgUserRowData = row;
            },
            delUserOrgRelation(row){
                let ids = [row.userOrgId];
                this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.$http({
                        url: "sysUserOrg/delete",
                        method: "post",
                        data: ids
                    }).then(({data}) => {
                        if(data && data.code === 0){
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.getUserListByOrgId(row.orgId);
                                }
                            });
                        }else{
                            this.$message.error(data.msg);
                        }
                    });
                });
            },
            contentStyleChange() {
                this.contentSearchStyleChange()
                this.contentBtnAdAllStyleChange()
                this.contentSearchBtnStyleChange()
                this.contentTableBtnStyleChange()
                this.contentPageStyleChange()
            },
            contentSearchStyleChange() {
                this.$nextTick(() => {
                    document.querySelectorAll('.form-content .slt .el-input__inner').forEach(el => {
                        let textAlign = 'left'
                        if(this.contents.inputFontPosition == 2)
                        textAlign = 'center'
                        if (this.contents.inputFontPosition == 3) textAlign = 'right'
                        el.style.textAlign = textAlign
                        el.style.height = this.contents.inputHeight
                        el.style.lineHeight = this.contents.inputHeight
                        el.style.color = this.contents.inputFontColor
                        el.style.fontSize = this.contents.inputFontSize
                        el.style.borderWidth = this.contents.inputBorderWidth
                        el.style.borderStyle = this.contents.inputBorderStyle
                        el.style.borderColor = this.contents.inputBorderColor
                        el.style.borderRadius = this.contents.inputBorderRadius
                        el.style.backgroundColor = this.contents.inputBgColor
                    })
                    if (this.contents.inputTitle) {
                        document.querySelectorAll('.form-content .slt .el-form-item__label').forEach(el => {
                            el.style.color = this.contents.inputTitleColor
                            el.style.fontSize = this.contents.inputTitleSize
                            el.style.lineHeight = this.contents.inputHeight
                        })
                    }
                    setTimeout(() => {
                        document.querySelectorAll('.form-content .slt .el-input__prefix').forEach(el => {
                            el.style.color = this.contents.inputIconColor
                            el.style.lineHeight = this.contents.inputHeight
                        })
                        document.querySelectorAll('.form-content .slt .el-input__suffix').forEach(el => {
                            el.style.color = this.contents.inputIconColor
                            el.style.lineHeight = this.contents.inputHeight
                        })
                        document.querySelectorAll('.form-content .slt .el-input__icon').forEach(el => {
                            el.style.lineHeight = this.contents.inputHeight
                        })
                    }, 10 )
                })
            },
            // 搜索按钮
            contentSearchBtnStyleChange() {
                this.$nextTick(() => {
                    document.querySelectorAll('.form-content .slt .el-button--success').forEach(el => {
                        el.style.height = this.contents.searchBtnHeight
                        el.style.color = this.contents.searchBtnFontColor
                        el.style.fontSize = this.contents.searchBtnFontSize
                        el.style.borderWidth = this.contents.searchBtnBorderWidth
                        el.style.borderStyle = this.contents.searchBtnBorderStyle
                        el.style.borderColor = this.contents.searchBtnBorderColor
                        el.style.borderRadius = this.contents.searchBtnBorderRadius
                        el.style.backgroundColor = this.contents.searchBtnBgColor
                    })
                })
            },
            // 新增、批量删除
            contentBtnAdAllStyleChange() {
                this.$nextTick(() => {
                    document.querySelectorAll('.form-content .ad .el-button--success').forEach(el => {
                        el.style.height = this.contents.btnAdAllHeight
                        el.style.color = this.contents.btnAdAllAddFontColor
                        el.style.fontSize = this.contents.btnAdAllFontSize
                        el.style.borderWidth = this.contents.btnAdAllBorderWidth
                        el.style.borderStyle = this.contents.btnAdAllBorderStyle
                        el.style.borderColor = this.contents.btnAdAllBorderColor
                        el.style.borderRadius = this.contents.btnAdAllBorderRadius
                        el.style.backgroundColor = this.contents.btnAdAllAddBgColor
                    })
                    document.querySelectorAll('.form-content .ad .el-button--danger').forEach(el => {
                        el.style.height = this.contents.btnAdAllHeight
                        el.style.color = this.contents.btnAdAllDelFontColor
                        el.style.fontSize = this.contents.btnAdAllFontSize
                        el.style.borderWidth = this.contents.btnAdAllBorderWidth
                        el.style.borderStyle = this.contents.btnAdAllBorderStyle
                        el.style.borderColor = this.contents.btnAdAllBorderColor
                        el.style.borderRadius = this.contents.btnAdAllBorderRadius
                        el.style.backgroundColor = this.contents.btnAdAllDelBgColor
                    })
                    document.querySelectorAll('.form-content .ad .el-button--warning').forEach(el => {
                        el.style.height = this.contents.btnAdAllHeight
                        el.style.color = this.contents.btnAdAllWarnFontColor
                        el.style.fontSize = this.contents.btnAdAllFontSize
                        el.style.borderWidth = this.contents.btnAdAllBorderWidth
                        el.style.borderStyle = this.contents.btnAdAllBorderStyle
                        el.style.borderColor = this.contents.btnAdAllBorderColor
                        el.style.borderRadius = this.contents.btnAdAllBorderRadius
                        el.style.backgroundColor = this.contents.btnAdAllWarnBgColor
                    })
                })
            },
            // 表格
            rowStyle({row, rowIndex}) {
                if (rowIndex % 2 == 1) {
                    if (this.contents.tableStripe) {
                        return {color: this.contents.tableStripeFontColor}
                    }
                } else {
                    return ''
                }
            },
            cellStyle({row, rowIndex}) {
                if (rowIndex % 2 == 1) {
                    if (this.contents.tableStripe) {
                        return {backgroundColor: this.contents.tableStripeBgColor}
                    }
                } else {
                    return ''
                }
            },
            headerRowStyle({row, rowIndex}) {
                return {color: this.contents.tableHeaderFontColor}
            },
            headerCellStyle({row, rowIndex}) {
                return {backgroundColor: this.contents.tableHeaderBgColor}
            },
            // 表格按钮
            contentTableBtnStyleChange() {
            },
            // 分页
            contentPageStyleChange() {
                let arr = []
                if (this.contents.pageTotal) arr.push('total')
                if (this.contents.pageSizes) arr.push('sizes')
                if (this.contents.pagePrevNext) {
                    arr.push('prev')
                    if (this.contents.pagePager) arr.push('pager')
                    arr.push('next')
                }
                if (this.contents.pageJumper) arr.push('jumper')
                this.layouts = arr.join()
                this.contents.pageEachNum = 10
            },

            addCity(node){
                this.addOrUpdateFlag = true;
                node.orgType='2';
                node.type = 'add';
                this.rowData = node;
            }
        }
    };
</script>
<style>
    .org-container {
        height: calc(100vh - 160px);
        min-height: 500px;
        border: 1px solid #e4e7ed;
        border-radius: 6px;
        overflow: hidden;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    }

    .org-aside {
        background: linear-gradient(180deg, #3a6ea5 0%, #2b5797 100%);
        border-right: 1px solid #2b5797;
        overflow-y: auto;
    }

    .aside-header {
        display: flex;
        align-items: center;
        padding: 16px 20px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.95);
        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
        background: rgba(0, 0, 0, 0.1);
    }

    .aside-header i {
        margin-right: 8px;
        font-size: 20px;
        color: #ffd591;
    }

    .org-tree-menu {
        border-right: none;
        background: transparent !important;
        background-color: transparent !important;
    }

    .org-tree-menu .el-menu {
        background-color: transparent !important;
    }

    .org-tree-menu .el-submenu {
        background-color: transparent !important;
    }

    .org-tree-menu .el-submenu__title {
        color: #fff !important;
        background-color: transparent !important;
        height: 48px;
        line-height: 48px;
        font-size: 14px;
    }

    .org-tree-menu .el-submenu__title i {
        color: #fff !important;
    }

    .org-tree-menu .el-submenu__title .el-submenu__icon-arrow {
        color: rgba(255, 255, 255, 0.7) !important;
    }

    .org-tree-menu .el-submenu__title:hover {
        background-color: rgba(255, 255, 255, 0.12) !important;
        color: #ffd591 !important;
    }

    .org-tree-menu .el-submenu__title:hover i {
        color: #ffd591 !important;
    }

    .org-tree-menu .el-menu-item {
        height: 44px;
        line-height: 44px;
        border-radius: 4px;
        margin: 2px 8px;
        transition: all 0.25s ease;
        color: rgba(255, 255, 255, 0.9) !important;
        background-color: transparent !important;
        font-size: 14px;
    }

    .org-tree-menu .el-menu-item i {
        color: #ffd591 !important;
    }

    .org-tree-menu .el-menu-item:hover {
        background-color: rgba(255, 255, 255, 0.12) !important;
        color: #ffd591 !important;
    }

    .org-tree-menu .el-menu-item:hover i {
        color: #ffd591 !important;
    }

    .org-tree-menu .el-menu-item.is-active {
        color: #fff !important;
        background-color: rgba(255, 255, 255, 0.2) !important;
        font-weight: 600;
    }

    .org-tree-menu .el-menu-item.is-active i {
        color: #ffd591 !important;
    }

    .org-tree-menu .el-menu--inline {
        background-color: rgba(0, 0, 0, 0.08) !important;
    }

    .org-tree-menu .el-menu--inline .el-menu-item {
        color: rgba(255, 255, 255, 0.9) !important;
        background-color: transparent !important;
    }

    .org-main {
        padding: 20px;
        background: #fff;
    }

    .org-table {
        width: 100%;
        border-radius: 4px;
    }

    .org-table .el-table__header th {
        background-color: #f5f7fa;
        color: #303133;
        font-weight: 600;
    }

    .form-content .slt .el-form-item {
        margin-bottom: 16px;
    }

    /* 右键菜单样式 */
    .context-menu {
        position: absolute;
        z-index: 100;
        min-width: 160px;
        background: #fff;
        border: 1px solid #e4e7ed;
        border-radius: 6px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        padding: 4px 0;
    }

    .context-menu-item {
        display: flex;
        align-items: center;
        padding: 10px 20px;
        font-size: 14px;
        color: #606266;
        cursor: pointer;
        transition: all 0.25s ease;
    }

    .context-menu-item i {
        margin-right: 8px;
        font-size: 16px;
    }

    .context-menu-item:hover {
        background-color: rgba(58, 110, 165, 0.08);
        color: var(--publicMainColor);
    }

    .context-menu-item--danger {
        color: #e74c3c;
    }

    .context-menu-item--danger:hover {
        background-color: #fef0f0;
        color: #e74c3c;
    }

    .context-menu-item--cancel {
        color: #909399;
        border-top: 1px solid #ebeef5;
        margin-top: 4px;
    }

    .context-menu-item--cancel:hover {
        background-color: #f5f7fa;
        color: #909399;
    }
</style>

<style scoped>
    .mainClass {
        width: 500px;
        height: 500px;
        background-color: #f0f0f0;
    }
</style>